import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, OnInit, QueryList, ViewContainerRef } from '@angular/core';
import { LayerApi } from '../../../api/layer-api';
import { util } from '../../../classes/util';
import { BaseComponent } from '../../../components/base.component';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { SplitThemeService } from '../../../services/split-theme.service';
import { isDynamicDataLayerSource, isGeometryDataSource, isGroupLayer, isMapImageLayer, isSimpleRenderer, isSymbolWithOutline, isSymbolWithWidth } from '../../../types';
var SymbolUtils;
var SplitThemeEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SplitThemeEditorComponent, _super);
    function SplitThemeEditorComponent(vcr, layerService, layerApi, splitThemeService) {
        var _this = _super.call(this, vcr, true) || this;
        _this.layerService = layerService;
        _this.layerApi = layerApi;
        _this.splitThemeService = splitThemeService;
        _this.useEsriScheme = false;
        _this.useSymbolScheme = false;
        _this.DEFAULT_NUM_CLASSES = 5;
        _this.loadingData = false;
        _this.wasOpen = false;
        _this.recreateGroupLayer = false;
        _this.applyColorToEntireLayer = false;
        _this.availableClassBreaks = [];
        return _this;
    }
    Object.defineProperty(SplitThemeEditorComponent.prototype, "displayRendererType", {
        get: function () {
            return (this.errorMessage && this.attemptedRendererType) || (this.theme && this.theme.rendererType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SplitThemeEditorComponent.prototype, "selectedClassBreaks", {
        get: function () {
            return this.theme.classBreaks.filter(function (cb) { return cb.selected; });
        },
        enumerable: true,
        configurable: true
    });
    SplitThemeEditorComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.SymbolUtils];
                    case 1:
                        SymbolUtils = _a.sent();
                        this.symbolEditorWindow = window.document.getElementById('symbolEditorWindow');
                        this.symbolEditor = window.document.getElementById('symbolEditor');
                        window.addEventListener('newSymbols', function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                            return [2 /*return*/, this.updateThemeSymbols(e)];
                        }); }); });
                        this.getClosestAncestor('mc-window').then(function (window) {
                            if (window) {
                                _this.windowRef = window;
                                _this.windowRef.addEventListener('openChange', function (open) {
                                    if (open.detail) {
                                        _this.windowOpened();
                                    }
                                    else {
                                        _this.destroyComponent();
                                    }
                                    _this.wasOpen = open.detail;
                                });
                            }
                            else {
                                _this.windowOpened();
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    SplitThemeEditorComponent.prototype.watchSymbolPreviewChanges = function () {
        var _this = this;
        this.symbolPreviewsSub = this.symbolPreviews.changes.subscribe(function (_) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.renderSymbols()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); });
    };
    SplitThemeEditorComponent.prototype.unwatchSymbolPreviewChanges = function () {
        if (this.symbolPreviewsSub) {
            this.symbolPreviewsSub.unsubscribe();
            this.symbolPreviewsSub = null;
        }
    };
    SplitThemeEditorComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        if (!this.mapViewRef) return [3 /*break*/, 1];
                        _b = this.mapViewRef;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 2:
                        _b = _c.sent();
                        _c.label = 3;
                    case 3:
                        _a.mapViewRef = _b;
                        this.splitThemeService.mapView = this.mapViewRef;
                        this.isReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    SplitThemeEditorComponent.prototype.windowOpened = function () {
        var layer = this.layerService.getEsriLayerByUniqueId(this.layerId);
        this.classBreakToAdd = null;
        this.changedColorClassBreaks = [];
        if (layer.mapcoreProps && layer.mapcoreProps.splitTheme && !isGroupLayer(layer.parent)) {
            this.loadTheme(layer.mapcoreProps.splitTheme);
        }
        else if (isMapImageLayer(layer)) {
            this.originalLayer = layer;
            this.generateClassBreaks('unique-value', true, layer);
        }
        else {
            throw new Error('Unsupported layer type for Theme Editor');
        }
        if (!this.wasOpen) {
            this.watchSymbolPreviewChanges();
        }
    };
    SplitThemeEditorComponent.prototype.closeWindow = function (save) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.unwatchSymbolPreviewChanges();
                        if (!save) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.applyTheme()];
                    case 1:
                        _a.sent();
                        this.updateLayersFromTheme();
                        this.saveTheme();
                        _a.label = 2;
                    case 2:
                        if (this.windowRef) {
                            this.windowRef.close();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SplitThemeEditorComponent.prototype.renderSymbols = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, _loop_1, this_1, _b, _c, symbolContainer, e_1_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.theme) {
                            return [2 /*return*/];
                        }
                        _loop_1 = function (symbolContainer) {
                            var e_2, _a, e_3, _b, _c, _d, child, classBreak, _e, _f, symbol, symbolWithLayerOpacity, e_3_1;
                            return tslib_1.__generator(this, function (_g) {
                                switch (_g.label) {
                                    case 0:
                                        try {
                                            for (_c = tslib_1.__values(Array.from(symbolContainer.nativeElement.childNodes)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                                child = _d.value;
                                                symbolContainer.nativeElement.removeChild(child);
                                            }
                                        }
                                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                        finally {
                                            try {
                                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                            }
                                            finally { if (e_2) throw e_2.error; }
                                        }
                                        classBreak = this_1.theme.classBreaks.find(function (cb) { return cb.info.label === symbolContainer.nativeElement.dataset.label; });
                                        _g.label = 1;
                                    case 1:
                                        _g.trys.push([1, 6, 7, 8]);
                                        _e = tslib_1.__values(classBreak.symbols), _f = _e.next();
                                        _g.label = 2;
                                    case 2:
                                        if (!!_f.done) return [3 /*break*/, 5];
                                        symbol = _f.value;
                                        symbolWithLayerOpacity = util.deepClone(symbol);
                                        symbolWithLayerOpacity.color.a *= classBreak.opacity;
                                        if (symbolWithLayerOpacity.outline) {
                                            symbolWithLayerOpacity.outline.color.a *= classBreak.opacity;
                                        }
                                        return [4 /*yield*/, SymbolUtils.renderPreviewHTML(symbolWithLayerOpacity, { maxSize: 14, scale: true, node: symbolContainer.nativeElement, size: { width: 29 } })];
                                    case 3:
                                        _g.sent();
                                        _g.label = 4;
                                    case 4:
                                        _f = _e.next();
                                        return [3 /*break*/, 2];
                                    case 5: return [3 /*break*/, 8];
                                    case 6:
                                        e_3_1 = _g.sent();
                                        e_3 = { error: e_3_1 };
                                        return [3 /*break*/, 8];
                                    case 7:
                                        try {
                                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                        return [7 /*endfinally*/];
                                    case 8: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _b = tslib_1.__values(this.symbolPreviews.toArray()), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 5];
                        symbolContainer = _c.value;
                        return [5 /*yield**/, _loop_1(symbolContainer)];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Loads a copy of a theme into the editor.
     * @param theme The theme to load.
     */
    SplitThemeEditorComponent.prototype.loadTheme = function (theme) {
        var _this = this;
        var e_4, _a;
        this.layerColumns = theme.layerColumns;
        this.selectedField = theme.field;
        this.availableClassBreaks = theme.classBreaks.filter(function (cb) { return !cb.selected; });
        if (theme.rendererType === 'unique-value') {
            // Reorder the class breaks in case their layers have been moved, and make copies of them so the changes can be cancelled
            var classBreaks = theme.classBreaks
                .filter(function (cb) { return !cb.selected; })
                .map(function (cb) { return _this.copyClassBreak(cb); });
            var _loop_2 = function (layer) {
                var classBreak = theme.classBreaks.find(function (cb) { return cb.info.label === layer.mapcoreProps.splitThemeLabel; });
                classBreaks.push(this_2.copyClassBreak(classBreak));
            };
            var this_2 = this;
            try {
                for (var _b = tslib_1.__values(theme.groupLayer.layers.toArray().reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var layer = _c.value;
                    _loop_2(layer);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            this.theme = tslib_1.__assign({}, theme, { classBreaks: classBreaks });
        }
        else {
            this.theme = tslib_1.__assign({}, theme, { classBreaks: theme.classBreaks.map(function (cb) { return _this.copyClassBreak(cb); }) });
        }
    };
    SplitThemeEditorComponent.prototype.copyClassBreak = function (classBreak) {
        return tslib_1.__assign({}, classBreak, { info: tslib_1.__assign({}, classBreak.info), symbols: classBreak.symbols.map(function (sym) { return sym.clone(); }) });
    };
    SplitThemeEditorComponent.prototype.saveTheme = function () {
        var _this = this;
        this.theme.groupLayer.mapcoreProps.splitTheme = this.theme;
        this.theme.groupLayer.layers.forEach(function (gl) { return gl.mapcoreProps.splitTheme = _this.theme; });
    };
    SplitThemeEditorComponent.prototype.toggleRendererType = function () {
        if (this.displayRendererType === 'unique-value') {
            this.attemptedRendererType = 'class-break';
            this.refreshTheme('class-break');
        }
        else {
            this.attemptedRendererType = 'unique-value';
            this.refreshTheme('unique-value');
        }
    };
    SplitThemeEditorComponent.prototype.initializeTheme = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerId, query, recordCount, selectedColumn, currentSubLayer;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layerId = this.theme ? this.theme.parentLayerId : layer.mapcoreProps.id || layer.mapcoreProps.parentId;
                        query = this.theme ? this.theme.query : layer.sublayers.getItemAt(0).source.dataSource.query;
                        return [4 /*yield*/, this.layerApi.getLayerRecordCount(layerId, JSON.parse(query))];
                    case 1:
                        recordCount = _a.sent();
                        if (!recordCount || recordCount.length === 0 || recordCount[0].recordCount === 0) {
                            this.loadingData = false;
                            return [2 /*return*/];
                        }
                        if (!this.theme) {
                            currentSubLayer = layer.sublayers.getItemAt(0);
                            if (!isDynamicDataLayerSource(currentSubLayer.source) || !isGeometryDataSource(currentSubLayer.source.dataSource)) {
                                return [2 /*return*/, false];
                            }
                            this.layerColumns = this.splitThemeService.getLayerColumnsFromLayer(layer);
                            this.selectedField = this.layerColumns[0].name;
                            this.theme = {
                                parentLayerId: layer.mapcoreProps.parentId,
                                originalOpacity: layer.opacity,
                                parentQuery: layer.mapcoreProps.parentQuery,
                                childQuery: layer.mapcoreProps.query,
                                visualVariables: this.layerService.getRendererDefinitionsForLayer(layer)[0].visualVariables,
                                baseSymbols: layer.sublayers.toArray().map(function (l) { return l.renderer.symbol; }),
                                layerColumns: this.layerColumns,
                                field: this.layerColumns[0].name,
                                isDate: false,
                                isNumeric: false,
                                query: query,
                                rendererType: 'unique-value',
                                numClasses: this.DEFAULT_NUM_CLASSES,
                                classBreaks: []
                            };
                        }
                        selectedColumn = this.theme.layerColumns.find(function (x) { return x.name === _this.selectedField; });
                        this.theme.field = this.selectedField;
                        this.theme.isDate = selectedColumn && selectedColumn.databaseDataType && selectedColumn.name.toUpperCase().includes('DATE');
                        return [2 /*return*/];
                }
            });
        });
    };
    SplitThemeEditorComponent.prototype.generateClassBreaks = function (rendererType, changeField, layer) {
        if (changeField === void 0) { changeField = false; }
        if (layer === void 0) { layer = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, validationMessage, previousColors, colorSets, resetClassBreaks, previousClassBreakCount, _loop_3, this_3, i;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.errorMessage = '';
                        this.loadingData = true;
                        return [4 /*yield*/, this.initializeTheme(layer)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.splitThemeService.getLayerClassBreakData(this.theme.parentLayerId, this.theme.field, this.theme.numClasses, rendererType === 'unique-value', JSON.parse(this.theme.query), this.theme.isDate)];
                    case 2:
                        result = _a.sent();
                        if (!(changeField && rendererType === 'unique-value' && (result.IsNumericData || this.theme.isDate))) return [3 /*break*/, 4];
                        rendererType = 'class-break';
                        if (this.splitThemeService.validateClassBreakCount(rendererType, result.ClassBreakInfos.length)) {
                            this.theme.numClasses = this.DEFAULT_NUM_CLASSES;
                        }
                        return [4 /*yield*/, this.splitThemeService.getLayerClassBreakData(this.theme.parentLayerId, this.theme.field, this.theme.numClasses, false, JSON.parse(this.theme.query), this.theme.isDate)];
                    case 3:
                        result = _a.sent();
                        _a.label = 4;
                    case 4:
                        validationMessage = this.splitThemeService.validateClassBreakCount(rendererType, result.ClassBreakInfos.length);
                        if (validationMessage) {
                            this.loadingData = false;
                            this.errorMessage = validationMessage;
                            return [2 /*return*/];
                        }
                        previousColors = this.theme.classBreaks ? this.theme.classBreaks.map(function (cb) { return cb.symbols[0].color; }) : [];
                        return [4 /*yield*/, this.splitThemeService.getClassColors(result.ClassBreakInfos.length, previousColors, this.theme.baseSymbols[0], this.useSymbolScheme, this.useEsriScheme)];
                    case 5:
                        colorSets = (_a.sent())[0];
                        resetClassBreaks = changeField || rendererType === 'class-break' || rendererType !== this.theme.rendererType;
                        previousClassBreakCount = resetClassBreaks ? 0 : this.theme.classBreaks.length;
                        this.theme.isNumeric = result.IsNumericData;
                        _loop_3 = function (i) {
                            this_3.theme.classBreaks[i] = {
                                selected: true,
                                info: result.ClassBreakInfos[i],
                                layer: null,
                                opacity: this_3.theme.originalOpacity,
                                symbols: this_3.theme.baseSymbols.map(function (bs) {
                                    var symbol = util.deepClone(bs);
                                    symbol.color = colorSets[i];
                                    if (isSymbolWithOutline(symbol)) {
                                        symbol.outline.color = colorSets[i];
                                    }
                                    return symbol;
                                })
                            };
                        };
                        this_3 = this;
                        for (i = previousClassBreakCount; i < result.ClassBreakInfos.length; i++) {
                            _loop_3(i);
                        }
                        this.theme.classBreaks.length = result.ClassBreakInfos.length;
                        this.theme.rendererType = rendererType;
                        this.loadingData = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SplitThemeEditorComponent.prototype.refreshTheme = function (rendererType, changeField) {
        if (rendererType === void 0) { rendererType = null; }
        if (changeField === void 0) { changeField = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.generateClassBreaks(rendererType || this.theme.rendererType, changeField)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SplitThemeEditorComponent.prototype.changeField = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.recreateGroupLayer = true;
                        this.attemptedRendererType = null;
                        return [4 /*yield*/, this.refreshTheme('unique-value', true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates and performs updates on the theme group layer.
     */
    SplitThemeEditorComponent.prototype.applyTheme = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_5, _a, e_6, _b, e_7, _c, e_8, _d, e_9, _e, e_10, _f, groupParent, _loop_4, _g, _h, classBreak, selectedLabels, originalLayerIndex, layers, _loop_5, this_4, _j, _k, _l, i, themeLayer, previouslySelectedLabels_1, addLayers_1, removeLayers, updatedLayers, _loop_6, this_5, _m, _o, classBreak, e_7_1, removeLayers_1, removeLayers_1_1, removedLayer, layers, tempGroup, _loop_7, this_6, _p, _q, _r, i, addedLayer, _s, _t, _u, i, classBreak;
            var _this = this;
            return tslib_1.__generator(this, function (_v) {
                switch (_v.label) {
                    case 0:
                        this.loadingData = true;
                        groupParent = this.configureGroupLayer();
                        _loop_4 = function (classBreak) {
                            var layerConfiguration = groupParent.layers.find(function (lc) { return lc.label === classBreak.info.label; });
                            layerConfiguration.renderers = classBreak.symbols.map(function (symbol) { return ({
                                type: 'simple',
                                visualVariables: _this.theme.visualVariables,
                                symbol: symbol
                            }); });
                        };
                        try {
                            for (_g = tslib_1.__values(this.selectedClassBreaks), _h = _g.next(); !_h.done; _h = _g.next()) {
                                classBreak = _h.value;
                                _loop_4(classBreak);
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        selectedLabels = this.selectedClassBreaks.map(function (cb) { return cb.info.label; });
                        originalLayerIndex = this.theme.groupLayer && this.mapViewRef.map.layers.indexOf(this.theme.groupLayer);
                        if (!(!this.theme.groupLayer || this.recreateGroupLayer)) return [3 /*break*/, 2];
                        // Create the group layer, or recreate it if the number of class breaks has changed
                        if (this.theme.groupLayer) {
                            this.layerService.removeLayer(this.theme.groupLayer);
                        }
                        return [4 /*yield*/, this.layerService.addMapcoreLayersToMap(groupParent.layers)];
                    case 1:
                        layers = _v.sent();
                        this.theme.groupLayer = layers.find(function (layer) { return layer.type === 'group'; });
                        _loop_5 = function (i, themeLayer) {
                            var classBreak = this_4.theme.classBreaks.find(function (cb) { return cb.info.label === selectedLabels[i]; });
                            classBreak.layer = themeLayer;
                            themeLayer.mapcoreProps.splitTheme = this_4.theme;
                            themeLayer.mapcoreProps.splitThemeLabel = selectedLabels[i];
                        };
                        this_4 = this;
                        try {
                            for (_j = tslib_1.__values(this.theme.groupLayer.layers.toArray().entries()), _k = _j.next(); !_k.done; _k = _j.next()) {
                                _l = tslib_1.__read(_k.value, 2), i = _l[0], themeLayer = _l[1];
                                _loop_5(i, themeLayer);
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                        this.theme.groupLayer.layers.reverse();
                        this.theme.groupLayer.mapcoreProps.splitTheme = this.theme;
                        if (this.originalLayer) {
                            this.layerService.moveLayerBelow(this.theme.groupLayer, this.originalLayer);
                            this.originalLayer.visible = false;
                        }
                        else {
                            this.mapViewRef.map.layers.reorder(this.theme.groupLayer, originalLayerIndex);
                        }
                        return [3 /*break*/, 13];
                    case 2:
                        if (!this.theme.groupLayer) return [3 /*break*/, 13];
                        previouslySelectedLabels_1 = this.theme.groupLayer.layers.map(function (gl) { return gl.mapcoreProps.splitThemeLabel; });
                        addLayers_1 = groupParent.layers.filter(function (lc) { return !previouslySelectedLabels_1.includes(lc.label); });
                        removeLayers = this.theme.groupLayer.layers.toArray().filter(function (gl) { return !selectedLabels.includes(gl.mapcoreProps.splitThemeLabel); });
                        updatedLayers = false;
                        _loop_6 = function (classBreak) {
                            var query, rangeQuery, minValue, maxValue;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        classBreak.layer.opacity = classBreak.opacity;
                                        if (!(this_5.theme.rendererType === 'class-break')) return [3 /*break*/, 2];
                                        query = classBreak.layer.mapcoreProps.query;
                                        rangeQuery = this_5.findRangeQuery(query);
                                        minValue = classBreak.info.minValue.toString();
                                        maxValue = classBreak.info.maxValue.toString();
                                        if (!(rangeQuery.subqueries[0].value !== minValue || rangeQuery.subqueries[1].value !== maxValue)) return [3 /*break*/, 2];
                                        rangeQuery.subqueries[0].value = minValue;
                                        rangeQuery.subqueries[1].value = maxValue;
                                        return [4 /*yield*/, this_5.layerService.updateLayerFilter(classBreak.layer, query)];
                                    case 1:
                                        _a.sent();
                                        classBreak.layer.mapcoreProps.name = groupParent.layers.find(function (gl) { return gl.label === classBreak.info.label; }).name;
                                        updatedLayers = true;
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_5 = this;
                        _v.label = 3;
                    case 3:
                        _v.trys.push([3, 8, 9, 10]);
                        _m = tslib_1.__values(this.theme.classBreaks.filter(function (cb) { return cb.layer; })), _o = _m.next();
                        _v.label = 4;
                    case 4:
                        if (!!_o.done) return [3 /*break*/, 7];
                        classBreak = _o.value;
                        return [5 /*yield**/, _loop_6(classBreak)];
                    case 5:
                        _v.sent();
                        _v.label = 6;
                    case 6:
                        _o = _m.next();
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_7_1 = _v.sent();
                        e_7 = { error: e_7_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_o && !_o.done && (_c = _m.return)) _c.call(_m);
                        }
                        finally { if (e_7) throw e_7.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        try {
                            for (removeLayers_1 = tslib_1.__values(removeLayers), removeLayers_1_1 = removeLayers_1.next(); !removeLayers_1_1.done; removeLayers_1_1 = removeLayers_1.next()) {
                                removedLayer = removeLayers_1_1.value;
                                this.theme.groupLayer.remove(removedLayer);
                            }
                        }
                        catch (e_8_1) { e_8 = { error: e_8_1 }; }
                        finally {
                            try {
                                if (removeLayers_1_1 && !removeLayers_1_1.done && (_d = removeLayers_1.return)) _d.call(removeLayers_1);
                            }
                            finally { if (e_8) throw e_8.error; }
                        }
                        if (!(addLayers_1.length > 0)) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.layerService.addMapcoreLayersToMap(addLayers_1)];
                    case 11:
                        layers = _v.sent();
                        tempGroup = layers.find(function (layer) { return layer.type === 'group'; });
                        _loop_7 = function (i, addedLayer) {
                            var classBreak = this_6.theme.classBreaks.find(function (cb) { return cb.info.label === addLayers_1[i].label; });
                            classBreak.layer = addedLayer;
                            addedLayer.mapcoreProps.groupParent.groupId = this_6.theme.groupLayer.id;
                            addedLayer.mapcoreProps.splitTheme = this_6.theme;
                            addedLayer.mapcoreProps.splitThemeLabel = addLayers_1[i].label;
                            this_6.theme.groupLayer.add(addedLayer);
                        };
                        this_6 = this;
                        try {
                            for (_p = tslib_1.__values(tempGroup.layers.toArray().entries()), _q = _p.next(); !_q.done; _q = _p.next()) {
                                _r = tslib_1.__read(_q.value, 2), i = _r[0], addedLayer = _r[1];
                                _loop_7(i, addedLayer);
                            }
                        }
                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
                        finally {
                            try {
                                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
                            }
                            finally { if (e_9) throw e_9.error; }
                        }
                        this.layerService.removeLayer(tempGroup);
                        _v.label = 12;
                    case 12:
                        try {
                            for (_s = tslib_1.__values(this.theme.classBreaks.entries()), _t = _s.next(); !_t.done; _t = _s.next()) {
                                _u = tslib_1.__read(_t.value, 2), i = _u[0], classBreak = _u[1];
                                if (classBreak.layer) {
                                    this.theme.groupLayer.layers.reorder(classBreak.layer, this.selectedClassBreaks.length - i - 1);
                                }
                            }
                        }
                        catch (e_10_1) { e_10 = { error: e_10_1 }; }
                        finally {
                            try {
                                if (_t && !_t.done && (_f = _s.return)) _f.call(_s);
                            }
                            finally { if (e_10) throw e_10.error; }
                        }
                        if (updatedLayers && removeLayers.length === 0 && addLayers_1.length === 0) {
                            // Trigger a layer refresh in case the layer titles changed
                            this.layerService.refreshLayers();
                        }
                        _v.label = 13;
                    case 13:
                        this.loadingData = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SplitThemeEditorComponent.prototype.configureGroupLayer = function () {
        var _this = this;
        var e_11, _a;
        var groupParent = {
            layers: [],
            name: this.originalLayer
                ? this.originalLayer.mapcoreProps.name
                : this.theme.groupLayer.mapcoreProps.name,
            checked: true,
            isOpen: true
        };
        var query = this.theme.childQuery;
        var currentQuery = query.subqueries ? query.subqueries : [query];
        try {
            for (var _b = tslib_1.__values(this.selectedClassBreaks.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib_1.__read(_c.value, 2), i = _d[0], classBreak = _d[1];
                var info = classBreak.info;
                var label = '';
                var subquery = [];
                if (this.layerService.isProperQuery(query)) {
                    subquery.push.apply(subquery, tslib_1.__spread(currentQuery));
                }
                if (this.theme.rendererType === 'unique-value') {
                    label = info.label;
                    subquery.push(this.buildUniqueQuery(info, this.theme.field));
                }
                else {
                    label = info.minValue + " < " + info.maxValue;
                    var isLastBreak = (i === this.selectedClassBreaks.length - 1);
                    subquery.push(this.buildRangeQuery(info, this.theme.field, isLastBreak));
                }
                var selectedColumn = this.theme.layerColumns.find(function (lc) { return lc.name === _this.theme.field; });
                groupParent.layers.push({
                    id: this.theme.parentLayerId,
                    label: classBreak.info.label,
                    visible: true,
                    groupParent: groupParent,
                    name: (selectedColumn && selectedColumn.alias ? selectedColumn.alias : this.theme.field) + " (" + label + ")",
                    query: {
                        operator: 'AND',
                        subqueries: subquery
                    },
                    opacity: classBreak.opacity,
                    parentQuery: this.theme.parentQuery
                });
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_11) throw e_11.error; }
        }
        return groupParent;
    };
    SplitThemeEditorComponent.prototype.buildRangeQuery = function (classBreak, filterField, lastBreak) {
        if (lastBreak === void 0) { lastBreak = false; }
        return {
            name: 'classBreak',
            operator: 'AND',
            subqueries: [
                {
                    field: filterField,
                    operator: '>=',
                    value: classBreak.minValue.toString()
                },
                {
                    field: filterField,
                    operator: lastBreak ? '<=' : '<',
                    value: classBreak.maxValue.toString()
                }
            ]
        };
    };
    SplitThemeEditorComponent.prototype.buildUniqueQuery = function (info, filterField) {
        var val = info.value === null ? 'null' : info.value.toString();
        return {
            operator: 'AND',
            isHiddenFilter: true,
            subqueries: [
                {
                    field: filterField,
                    operator: val.toLowerCase() === 'null' ? 'IS NULL' : '=',
                    value: val.toLowerCase() === 'null' ? null : val
                }
            ]
        };
    };
    SplitThemeEditorComponent.prototype.findRangeQuery = function (query) {
        var e_12, _a;
        var queries = [query];
        while (queries.length > 0) {
            var current = queries.pop();
            if (current.name === 'classBreak') {
                return current;
            }
            if (current.operator === 'AND' || current.operator === 'OR') {
                try {
                    for (var _b = tslib_1.__values(current.subqueries), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var subquery = _c.value;
                        queries.push(subquery);
                    }
                }
                catch (e_12_1) { e_12 = { error: e_12_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_12) throw e_12.error; }
                }
            }
        }
        return null;
    };
    SplitThemeEditorComponent.prototype.resetColors = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_13, _a, e_14, _b, colorSets, _c, _d, _e, i, classBreak, _f, _g, symbol;
            return tslib_1.__generator(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4 /*yield*/, this.splitThemeService.getClassColors(this.theme.classBreaks.length, [], this.theme.baseSymbols[0], this.useSymbolScheme, this.useEsriScheme)];
                    case 1:
                        colorSets = (_h.sent())[0];
                        try {
                            for (_c = tslib_1.__values(this.theme.classBreaks.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
                                _e = tslib_1.__read(_d.value, 2), i = _e[0], classBreak = _e[1];
                                this.changedColorClassBreaks.push(classBreak.info.label);
                                try {
                                    for (_f = tslib_1.__values(classBreak.symbols), _g = _f.next(); !_g.done; _g = _f.next()) {
                                        symbol = _g.value;
                                        symbol.color = colorSets[i];
                                        if (isSymbolWithOutline(symbol)) {
                                            symbol.outline.color = colorSets[i];
                                        }
                                    }
                                }
                                catch (e_14_1) { e_14 = { error: e_14_1 }; }
                                finally {
                                    try {
                                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                                    }
                                    finally { if (e_14) throw e_14.error; }
                                }
                            }
                        }
                        catch (e_13_1) { e_13 = { error: e_13_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_13) throw e_13.error; }
                        }
                        return [4 /*yield*/, this.renderSymbols()];
                    case 2:
                        _h.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SplitThemeEditorComponent.prototype.stackLineWidths = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_15, _a, firstClassBreak, firstLineSymbol, lineWidth, _b, _c, classBreak;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        firstClassBreak = this.theme.classBreaks.find(function (x) { return x.selected; });
                        firstLineSymbol = firstClassBreak.symbols.find(isSymbolWithWidth);
                        if (!firstLineSymbol) {
                            return [2 /*return*/];
                        }
                        lineWidth = firstLineSymbol.width;
                        try {
                            for (_b = tslib_1.__values(this.selectedClassBreaks.slice(1)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                classBreak = _c.value;
                                lineWidth += 3;
                                classBreak.symbols.find(isSymbolWithWidth).width = lineWidth;
                                this.changedColorClassBreaks.push(classBreak.info.label);
                            }
                        }
                        catch (e_15_1) { e_15 = { error: e_15_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_15) throw e_15.error; }
                        }
                        return [4 /*yield*/, this.renderSymbols()];
                    case 1:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SplitThemeEditorComponent.prototype.editSymbol = function (classBreak) {
        if (this.symbolEditorWindow) {
            this.symbolEditorWindow.open();
            this.symbolEditor.symbols = classBreak.symbols.map(function (s) { return util.deepClone(s); });
            this.symbolEditor.opacity = classBreak.opacity * 100;
            this.currentSymbol = classBreak.info.label;
            this.changedColorClassBreaks.push(classBreak.info.label);
        }
    };
    SplitThemeEditorComponent.prototype.editClassBreak = function (classBreak) {
        this.newMinValue = classBreak.info.minValue;
        this.newMaxValue = classBreak.info.maxValue;
        this.classBreakToEdit = classBreak.info.label;
    };
    SplitThemeEditorComponent.prototype.saveClassBreak = function (classBreak) {
        var index = this.theme.classBreaks.indexOf(classBreak);
        var previousClassBreak = this.theme.classBreaks[index - 1];
        var nextClassBreak = this.theme.classBreaks[index + 1];
        if (previousClassBreak && this.newMinValue < previousClassBreak.info.minValue) {
            this.errorMessage = this.newMinValue + " is less than the previous class break's minimum of " + previousClassBreak.info.minValue;
            return;
        }
        else if (nextClassBreak && this.newMaxValue > nextClassBreak.info.maxValue) {
            this.errorMessage = this.newMaxValue + " is greater than the next class break's maximum of " + nextClassBreak.info.maxValue;
            return;
        }
        else {
            this.errorMessage = '';
        }
        classBreak.info.minValue = this.newMinValue;
        classBreak.info.maxValue = this.newMaxValue;
        if (previousClassBreak) {
            previousClassBreak.info.maxValue = this.newMinValue;
        }
        if (nextClassBreak) {
            nextClassBreak.info.minValue = this.newMaxValue;
        }
        this.classBreakToEdit = null;
    };
    SplitThemeEditorComponent.prototype.cancelEditClassBreak = function () {
        this.errorMessage = '';
        this.classBreakToEdit = null;
    };
    SplitThemeEditorComponent.prototype.editClassBreakKeyUp = function (classBreak, e) {
        if (e.code === 'Enter') {
            this.saveClassBreak(classBreak);
        }
        else if (e.code === 'Escape') {
            this.cancelEditClassBreak();
        }
    };
    SplitThemeEditorComponent.prototype.addClassBreak = function () {
        var _this = this;
        if (this.theme.rendererType === 'unique-value') {
            var classBreak = this.theme.classBreaks.find(function (cb) { return cb.info.label === _this.classBreakToAdd; });
            classBreak.selected = true;
            this.classBreakToAdd = null;
            this.configureGroupLayer();
            this.availableClassBreaks = this.theme.classBreaks.filter(function (cb) { return !cb.selected; });
        }
        else {
            this.theme.numClasses += 1;
            this.recreateGroupLayer = true;
            this.refreshTheme();
        }
    };
    SplitThemeEditorComponent.prototype.removeClassBreak = function (classBreak) {
        if (this.theme.rendererType === 'unique-value') {
            classBreak.selected = false;
            this.classBreakToAdd = null;
            this.configureGroupLayer();
            this.availableClassBreaks = this.theme.classBreaks.filter(function (cb) { return !cb.selected; });
        }
        else {
            this.theme.classBreaks.splice(this.theme.numClasses - 1, 1);
            this.theme.numClasses -= 1;
            this.recreateGroupLayer = true;
            this.refreshTheme();
        }
    };
    SplitThemeEditorComponent.prototype.moveValueUp = function (classBreak) {
        var index = this.theme.classBreaks.indexOf(classBreak);
        this.theme.classBreaks.splice(index, 1);
        for (var i = index - 1; i >= 0; i--) {
            if (this.theme.classBreaks[i].selected) {
                this.theme.classBreaks.splice(i, 0, classBreak);
                break;
            }
        }
    };
    SplitThemeEditorComponent.prototype.moveValueDown = function (classBreak) {
        var index = this.theme.classBreaks.indexOf(classBreak);
        this.theme.classBreaks.splice(index, 1);
        for (var i = index + 1; i <= this.theme.classBreaks.length; i++) {
            if (i === this.theme.classBreaks.length || this.theme.classBreaks[i - 1].selected) {
                this.theme.classBreaks.splice(i, 0, classBreak);
                break;
            }
        }
    };
    /**
     * Updates the theme when changing a symbol.
     * @param e The newSymbol event. If layerId is null, the symbols currently being edited from the theme editor are being changed.
     *          If layerId is not null, the specified layer's symbols are being changed from the legend.
     */
    SplitThemeEditorComponent.prototype.updateThemeSymbols = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_16, _a, theme, label, layer, classBreak, _b, _c, _d, i, newSymbol, i;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (e.detail.layerId) {
                            layer = this.layerService.getExistingEsriLayerById(e.detail.layerId);
                            theme = layer.mapcoreProps.splitTheme;
                            label = layer.mapcoreProps.splitThemeLabel;
                        }
                        else {
                            theme = this.theme;
                            label = this.currentSymbol;
                        }
                        if (!theme) {
                            return [2 /*return*/];
                        }
                        classBreak = theme.classBreaks.find(function (cb) { return cb.info.label === label; });
                        classBreak.opacity = e.detail.opacity / 100;
                        try {
                            for (_b = tslib_1.__values(e.detail.symbols.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                _d = tslib_1.__read(_c.value, 2), i = _d[0], newSymbol = _d[1];
                                if (!newSymbol) {
                                    break;
                                }
                                classBreak.symbols[i] = newSymbol;
                            }
                        }
                        catch (e_16_1) { e_16 = { error: e_16_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_16) throw e_16.error; }
                        }
                        if (this.symbolEditor.applyColorToEntireLayer) {
                            for (i = e.detail.symbols.length; i < classBreak.symbols.length; i++) {
                                classBreak.symbols[i].color = e.detail.symbols[0].color;
                            }
                        }
                        if (!this.windowRef.isOpened) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.renderSymbols()];
                    case 1:
                        _e.sent();
                        _e.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates theme layer renderers with the colors selected in the theme editor.
     */
    SplitThemeEditorComponent.prototype.updateLayersFromTheme = function () {
        var _this = this;
        var e_17, _a, e_18, _b;
        try {
            for (var _c = tslib_1.__values(this.theme.classBreaks.filter(function (cb) { return _this.changedColorClassBreaks.includes(cb.info.label); })), _d = _c.next(); !_d.done; _d = _c.next()) {
                var classBreak = _d.value;
                if (!classBreak.layer || !isMapImageLayer(classBreak.layer)) {
                    continue;
                }
                try {
                    for (var _e = tslib_1.__values(classBreak.symbols.entries()), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var _g = tslib_1.__read(_f.value, 2), j = _g[0], symbol = _g[1];
                        var sublayer = classBreak.layer.allSublayers.getItemAt(j);
                        if (isSimpleRenderer(sublayer.renderer)) {
                            sublayer.renderer.symbol = symbol;
                        }
                    }
                }
                catch (e_18_1) { e_18 = { error: e_18_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_18) throw e_18.error; }
                }
                window.dispatchEvent(new CustomEvent('symbolChange', { detail: classBreak.layer.id }));
            }
        }
        catch (e_17_1) { e_17 = { error: e_17_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_17) throw e_17.error; }
        }
    };
    SplitThemeEditorComponent.prototype.destroyComponent = function () {
        this.unwatchSymbolPreviewChanges();
        this.errorMessage = null;
        this.loadingData = false;
        this.recreateGroupLayer = false;
        this.theme = null;
        this.originalLayer = null;
        this.availableClassBreaks = [];
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], SplitThemeEditorComponent.prototype, "useEsriScheme", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], SplitThemeEditorComponent.prototype, "useSymbolScheme", void 0);
    return SplitThemeEditorComponent;
}(BaseComponent));
export { SplitThemeEditorComponent };
